import axios from '../config/axios'

export const postCompabilityCheck = (participantId, data) => axios.post(`/participant/checkCompatibility/${participantId}`, data)